import { Link } from "react-router-dom";
import { lazy, Suspense } from "react";
import footerLogo from "@/assets/ceg-logo-full-light.png.asset.json";

const FooterNavCards = lazy(() => import("@/components/FooterNavCards"));

const Footer = () => {
  return (
    <>
      <Suspense fallback={null}>
        <FooterNavCards />
      </Suspense>

      <footer className="bg-primary py-10 md:py-14 pb-24 md:pb-14 text-primary-foreground">
        <div className="container mx-auto px-4 relative">
          <img
            src={footerLogo.url}
            alt="California Energy Group logo"
            className="hidden sm:block absolute left-4 bottom-0 h-10 md:h-12 w-auto opacity-40"
            loading="lazy"
          />
          <div className="flex flex-col items-center gap-5 md:gap-6">
            {/* Brand mark (phones) */}
            <img
              src={footerLogo.url}
              alt="California Energy Group logo"
              className="sm:hidden h-16 w-auto opacity-50"
              loading="lazy"
            />

            {/* Editorial divider */}
            <div className="h-px w-16 bg-secondary mb-1" />

            {/* Legal Links */}
            <div className="flex items-center gap-4 md:gap-6 text-base md:text-lg text-background/70">
              <Link to="/privacy-policy" className="hover:text-background transition-colors">Privacy</Link>
              <Link to="/terms" className="hover:text-background transition-colors">Terms</Link>
              <Link to="/sms-opt-in" className="hover:text-background transition-colors">SMS Opt-In</Link>
              <Link to="/admin" className="hover:text-background transition-colors">Admin</Link>
            </div>

            {/* Copyright */}
            <div className="text-base md:text-lg text-background/50 text-center">
              &copy; 2022 California Energy Group. All rights reserved.
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
